/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 5/21/13
 * Time: 2:47 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Template = require("templates/userBar.tmpl");
    var Bubble = require("ui/bubble/Bubble");

    var UserBarLayout = Marionette.Layout.extend({
        withUIComponents: true,
        template: Template,
        regions: {
            "mainRegion" : ".user-bar-main",
            "personaSwitcher": ".user-bar-persona-switcher",
            "topLevelMenu": ".user-bar-top-level-menu",
            "trayMenu": ".user-bar-tray-menu",
            "userBarWidgets": ".user-bar-top-level-widgets"

        },
        ui:{
            "userBarTopLevelMenu": ".user-bar-top-level-menu"
        },
        events:{
            "click .user-bar-top-level-menu":"_closeBubble"
        },
        initialize: function () {
            //LE.vent.once("userBarTopLevelMenu:setBubble", this._setBubble, this);
        },
        onRender:function () {
        },
        _setBubble:function(){
            this.uiComponents.host$.createAndRender("topLevelMenuItemBubble", {
                type: Bubble,
                options: {
                    targetControl: this.ui.userBarTopLevelMenu,
                    text: LE.translator.translate("LEFramework.tagFlowBanner.LiveEngageTagPointer.bubble") ,
                    position: Bubble.POSITION.BOTTOM,
                    showCloseButton: true,
                    theme: Bubble.THEME.DARK
                }
            });
        },
        _closeBubble:function(){
            if (this.uiComponents && this.uiComponents.topLevelMenuItemBubble) {
                this.uiComponents.topLevelMenuItemBubble.close();
            }
        }
    });
    return UserBarLayout;
});